export default __webpack_public_path__ + "static/media/mini-banner.4fa1345f.png";